/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface MarketMakingTrackFileRequest {
  timestamp: string;
  basePairId: number;
  /**
   * Platform name without kaali_ prefix, e.g. FIGUREMARKETS, ZEROHASH, OKX.
   */
  platform: string;
}
